import { gql, TypedDocumentNode } from "@apollo/client";

import {
  CreateBlacklistElementMutation,
  CreateBlacklistElementMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { blacklistElementFragment } from "src/graphql/anti-fraud/fragments/BlacklistElementFragment.ts";

export const createBlacklistElementMutation = gql`
  mutation CreateBlacklistElement($blacklistCode: String!, $properties: [PropertyValueInput!]!) {
    createBlacklistElement(blacklistCode: $blacklistCode, options: { properties: $properties }) {
      id
      blacklist {
        code
      }
      adminStatus {
        creation
        lastModification
      }
      ...BlacklistElement
    }
  }

  ${blacklistElementFragment}
` as TypedDocumentNode<CreateBlacklistElementMutation, CreateBlacklistElementMutationVariables>;
